// add class body
jQuery(document).ready(function($){
  jQuery(".icon-icon").click(function(e){
	  jQuery('body').toggleClass('top-search-open');
		  e.preventDefault();
  });
});
// add class body
jQuery(document).ready(function($){
  jQuery(".background-icon").click(function(e){
	  jQuery('body').toggleClass('top-search-open');
		  e.preventDefault();
  });
});
// add class body
jQuery(document).ready(function($){
  jQuery(".icon-h-t-b").click(function(e){
	  jQuery('.header-top-bar').toggleClass('dropdow-header-open');
		  e.preventDefault();
  });
});
// slider
 $(window).load(function() {
  $(".testimonials-home1").owlCarousel({
    items : 1,
	itemsDesktop : false,
	itemsDesktopSmall : false,
	itemsTablet: false,
	itemsMobile : false,
	slideSpeed : 500,
	autoPlay: false
  });	
});
//
$(window).load(function() {
	$('.list-brand-block-slider').owlCarousel({
	autoPlay: 300000, //Set AutoPlay to 3 seconds
	items :3,
	itemsDesktop :3,
	itemsDesktopSmall : [900,2],
	itemsTablet: [600,2],
	itemsMobile : [320,1],
	slideSpeed :500,
	});
});
//
$(window).load(function() {
	$('.brands-slider').owlCarousel({
	autoPlay: 300000, //Set AutoPlay to 3 seconds
	items :1,
	itemsDesktop :1,
	itemsDesktopSmall : [900,1],
	itemsTablet: [600,1],
	itemsMobile : [320,1],
	slideSpeed :500,
	});
});
//
$(window).load(function() {
	$('#ProductThumbs').owlCarousel({
	autoPlay: true, //Set AutoPlay to 3 seconds
	items :4,
	itemsDesktop :4,
	itemsDesktopSmall : [900,3],
	itemsTablet: [600,3],
	itemsMobile : [320,2],
	slideSpeed :500,
	});
});
// auto margin
$(document).ready(function() {
var full_screen = function(){
	$('.fluid-width').each(function(){
		$(this).css({
			marginLeft : 'auto',
			marginRight : 'auto'
		});
		var width_w = $(window).width(),
			width_e = $(this).innerWidth();
		if(width_w > width_e){
			$(this).css({
				marginLeft : -(width_w - width_e) / 2,
				marginRight : -(width_w - width_e) / 2
			})
		}
	});
}
full_screen();
$(window).resize(function(){
	full_screen();
});
});
// skrollr background
jQuery(document).ready(function(){
	var skrollr_init = skrollr.init({
		mobileCheck: function() {
			return false;
		}
	});
})
// video background
function playVideo (video_id){
	var video = document.getElementById(video_id),
		wrap = jQuery(video).closest('.video-wrap'),
		play = wrap.find('.btn-video-play'),
		overlay = wrap.find('.video-overlay');
	if (video.paused) {
		video.play();
		overlay.hide();
		play.find('i').removeAttr('class').addClass('fa fa-play');
	} else {
		video.pause();
		overlay.show();
		play.find('i').removeAttr('class').addClass('fa fa-pause');
	}
}
function pauseVideo(video_id){
	playVideo(video_id);
}
function replayVideo(video_id){
	document.getElementById(video_id).load();
	playVideo(video_id);
}
function volumeVideo(video_id){
	var video = document.getElementById(video_id);
	var wrap = jQuery(video).closest('.video-wrap');
	if(video.volume > 0){
		wrap.find('.btn-video-volume').addClass('btn-video-volume-off');
		video.volume = 0;
	}else{
		wrap.find('.btn-video-volume').removeClass('btn-video-volume-off');
		video.volume = 1;
	}
}
// end video background

// product list/grid
function display(display){
  if(display == 'list'){
    jQuery('#products-viewmode').removeClass().addClass('products-list');
    jQuery('.products-list > .item').each(function(index, element) {
      var review_html = '';
      if( jQuery(element).find('.ratings-product-item') ){
        review_html = '<div class="ratings-product-item">'+ jQuery(element).find('.ratings-product-item').html() + '</div>';
      }
      jQuery(element).removeClass('col-lg-3 col-md-3 col-sm-3 col-xs-6');
      html = '     <div class="row">';
      html +='        <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">';
      html +='            <div class="products-list-inner">'; 
      html +='               <div class="item-product-image-box">';
      html +=                    jQuery(element).find('.item-product-image-box').html();
      html +='                </div>';
      html +='            </div>';
      html +='        </div>';
      html +='        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">';
      html +='            <div class="product-shop">'; 
      html +='                     <h2 class="product-name">'+ jQuery(element).find('.product-name').html() +'</h2>';
      html +=                      review_html;
      html +='                     <div class="price-box">'+ jQuery(element).find('.price-box').html() +'</div>';
      html +='                     <div class="desc-list">'+ jQuery(element).find('.desc-list').html() +'</div>';
      html +='                     <div class="quickview-wishlist-cart">'+ jQuery(element).find('.quickview-wishlist-cart').html().replace("<i class=\"fa fa-shopping-cart\"></i>", "<span class=\"gird-text\">Add to cart</span>") +'</div>';
      html +='            </div>';
      html +='        </div>';
      html +='    </div>';
      jQuery(element).html(html);
    });		
    $('.view-mode').find('.list').addClass('active');
    $('.view-mode').find('.grid').removeClass('active');
    $.totalStorage('display', 'list');
  }else{
  	jQuery('#products-viewmode').removeClass().addClass('row products-grid');
    jQuery('.products-grid > .item').each(function(index, element) {
      var review_html = '';
      if( jQuery(element).find('.ratings-product-item') ){
        review_html = '<div class="ratings-product-item">'+ jQuery(element).find('.ratings-product-item').html() + '</div>';
      }
      jQuery(element).addClass('col-lg-3 col-md-3 col-sm-3 col-xs-6');
      html = '    <div class="group-item">';
      html +='     <div class="item-product-image-box">'+ jQuery(element).find('.item-product-image-box').html() +'</div>';
      html +='    <div class="quickview-wishlist-cart">'+ jQuery(element).find('.quickview-wishlist-cart').html().replace("<span>Add to cart</span>", "<i class=\"nc-icon-outline shopping_bag-add-21\"></i>") +'</div>';
      html +='    </div>';
      html +='    <h3 class="product-name">'+ jQuery(element).find('.product-name').html() +'</h3>';
      html +='    <div class="price-box">'+ jQuery(element).find('.price-box').html() +'</div>';
      html +='    <div class="hidden-class"><div class="desc-list">'+ jQuery(element).find('.desc-list').html() +'</div></div>';
      html +=     review_html;      
      jQuery(element).html(html);
    });
    $('.view-mode').find('.list').removeClass('active');
    $('.view-mode').find('.grid').addClass('active');
    $.totalStorage('display', 'grid');
  }
}

// Add (+/-) Button Number Incrementers 
jQuery(document).on('click','.button-qty', function () {
  var $button = jQuery(this);
  var oldValue = $button.parent().find("input").val();

  if ($button.text() == "+") {
    var newVal = parseFloat(oldValue) + 1;
  } else {
    // Don't allow decrementing below zero
    if (oldValue > 1) {
      var newVal = parseFloat(oldValue) - 1;
    } else {
      newVal = 1;
    }
  }

  $button.parent().find("input").val(newVal);

});
// sticky header
$(window).load(function(){
  $(".header-sticky-style").sticky({ topSpacing: 0 });
});
/* Update mini cart html */
function updateMiniCart(){
  jQuery.ajax({
    type: 'GET',
    url: '/cart.js',
    dataType: 'json',
    success: function(cart_info){
      jQuery('.cart-count').text(cart_info.item_count);
      var cart_items_html = '';
      var cart_total = 0;
      if (cart_info.item_count > 0) {
        cart_items_html = '<div class="bag-contents">';
        for (var i = 0; i < cart_info.items.length; i++) {
          cart_total += (cart_info.items[i].price * cart_info.items[i].quantity);          
            var cart_item_html = '';
            cart_item_html += '<div class="item">';
            cart_item_html +=     '<div class="product-image">'
            cart_item_html +=         '<a href="'+cart_info.items[i].url+'" title="'+cart_info.items[i].title+'" class="image"><img src="'+Shopify.resizeImage(cart_info.items[i].image, "small")+'" width="87" height="103" alt="'+cart_info.items[i].title+'"></a>';
            cart_item_html +=     '</div>';
            cart_item_html +=     '<div class="product-details">';
            cart_item_html +=         '<div class="product-name">';
            cart_item_html +=             '<a href="'+cart_info.items[i].url+'">'+cart_info.items[i].title+'</a>';
            cart_item_html +=         '</div>';
            cart_item_html +=         '<span class="quantity">'+cart_info.items[i].quantity+'<span class="icon-nhan">X</span></span>';
            cart_item_html +=         '<span class="price">'+Shopify.formatMoney(cart_info.items[i].price, window.money_format)+'</span>';           
            cart_item_html +=         '<a href="javascript:;" onclick="changeCartProduct('+cart_info.items[i].id+', 0)" title="Remove This Item" class="btn-remove"><i class="nc-icon-outline ui-1_simple-remove"></i></a>';
            cart_item_html +=     '</div>';
            cart_item_html += '</div>';
            cart_item_html += '<hr>';
            cart_items_html += cart_item_html;         
        }        
        cart_items_html += '<div class="subtotal-group" style="padding: 30px 0px 35px;">';
        cart_items_html += '<span class="cart__subtotal-title" style="width: 50%; display: inline-block; text-align: right;"><strong style="text-transform: uppercase; font-size: 13px; color: rgb(85, 85, 85) ! important;">Subtotal:</strong></span>';
        cart_items_html += '<span class="h5 cart__subtotal" style="width: 48%; display: inline-block; text-align: right; margin: 0; font-size: 24px; font-weight: 300;">'+Shopify.formatMoney(cart_total, window.money_format)+'</span>';
        cart_items_html += '</div>';
        cart_items_html += '</div><div class="bag-buttons" style="margin-bottom: 15px;"><a href="/cart" class="sf-roll-button bag-button view-cart-r" style="margin-right: 5px;"><span>View Cart</span></a><a href="/checkout" class="sf-roll-button checkout-button view-cart-r"><span>Check Out</span></a></div>';
      }else{
        cart_items_html += '<div class="shopping-no-items"><p class="empty">You have no items in your shopping cart.</p></div>';
      }
      jQuery('.shopping-bag').html(cart_items_html);
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
    }
  });
};
/* End Update mini cart html */

/* Update cart product quantity */
function changeCartProduct(id, quantity){
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: 'id='+id+'&quantity='+quantity,
    success: function(data){
      updateMiniCart();
    }
  });
};
/* End Update cart product quantity */

/* Product list Add to cart */
function ajaxcart(id) {
  var addtocart_default_text = jQuery('.button-ajax-cart-id-'+id).html();
  if(!jQuery('.button-ajax-cart-id-'+id).hasClass('adding')){
    jQuery('.button-ajax-cart-id-'+id).addClass('adding').html('<i class="fa fa-circle-o-notch fa-spin"></i>');
    try {
      jQuery.ajax( {
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: 'id='+id+'&quantity=1',
        success : function(data) {
          jQuery('.button-ajax-cart-id-'+id).removeClass('adding').html(addtocart_default_text);  
          jQuery('#nova-notification .notification-content').html("The product <span>"+data.title+"</span> was added to your shopping cart.<br><a href=\"/cart\" class=\"button-readmore\">View Cart</a>");
          jQuery('#nova-notification').stop().fadeIn('slow', function(){
            setTimeout(function(){ jQuery('#nova-notification').stop().fadeOut('slow'); }, 4000);
          }); 
          updateMiniCart();
        }
      });
    } catch (e) {}
  }
}
/* End Product list Add to cart */
/* Add to wishlist */
jQuery(document).on('click','.act-wishlist', function () {
  var wishlist_btn = jQuery(this);
  try {
    jQuery.ajax( {
      type: 'POST',
      url: '/contact',
      data: wishlist_btn.attr('data-submit'),
      success : function() {
        wishlist_btn.addClass('active');
        jQuery('#nova-notification .notification-content').html('The product <span>'+wishlist_btn.attr('data-title')+'</span> has been added to your wishlist.<br><a href=\"/pages/wish-list\" class=\"button-readmore\">Go to Wishlist</a>');
        jQuery('#nova-notification').stop().fadeIn('slow', function(){
          setTimeout(function(){ jQuery('#nova-notification').stop().fadeOut('slow'); }, 4000);
        }); 
      }
    });
  } catch (e) {}
});
/* End Add to wishlist */